import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { useAuth } from './AuthContext';

function AuthTokenRefresh() {
  const { refreshToken, isAuthenticated } = useAuth();
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname + location.search + location.hash;
    oktaAuth.setOriginalUri(currentPath);
    refreshToken();
  }, [refreshToken, oktaAuth, location]);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectUri = oktaAuth.getOriginalUri() || '/search';
      navigate(redirectUri, { replace: true });
    }
  }, [navigate, isAuthenticated, oktaAuth]);

  return null;
}

export default AuthTokenRefresh;
